import { Injectable, signal } from '@angular/core';

export interface InterventionSelection {
  attributes: Record<string, any>;
  geometry?: any;
}

@Injectable({ providedIn: 'root' })
export class InterventionProfileService {
  readonly selected = signal<InterventionSelection | null>(null);
  readonly active = signal(false);

  select(attrs: Record<string, any>, geom?: any): void {
    this.selected.set({ attributes: attrs, geometry: geom });
    this.active.set(true);
  }

  clear(): void {
    this.selected.set(null);
    this.active.set(false);
  }
}
